module.exports = __webpack_public_path__ + "assets/img/2f3a65e56290702b188e7ed67887f338.png";